import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { StyledTableCell } from "../common/styles";
import { ColorPallet } from "../../utils/colorPallet";
import { ShelfHeaderData } from "../../utils/constants";
import { CustomPagination } from "../commontable/customPagination";
import ShelfInnerRow from "./shelfInnerRow";

interface IProps {
  page?: number;
  rowsPerPage?: number;
  totalCount?: number;
  onPageChange?: any;
  onRowsPerPageChange?: any;
  isPagination?: any;
  shelfData: any;
  setReloadShelf: any;
}

const ShelfTable = ({
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  isPagination,
  shelfData,
  setReloadShelf
}: IProps) => {
  const [openAddModal, setOpenAddModal] = useState(false);
  const [selectedShelf, setSelectedShelf] = useState(null);

  const handleOpenAddModal = (shelf?: any) => {
    setSelectedShelf(shelf || null);
    setOpenAddModal(true);
  };

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <TableContainer sx={{ maxHeight: "55vh", overflow: "auto" }}>
          <Table
            stickyHeader 
            sx={{
              border: "1px solid #D3D3D3",
              borderCollapse: "collapse", 
            }}
          >
            <TableHead>
              <TableRow sx={{ height: "12px" }}>
                {ShelfHeaderData.map((header: any, index: number) => (
                  <StyledTableCell
                    key={index}
                    sx={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      color: ColorPallet.primaryGrey,
                      fontSize: "16px",
                      fontWeight: 500,
                      border: "1px solid #D3D3D3",
                    }}
                  >
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
      {[...shelfData].reverse().map((shelf: any, index: number) => 
      (
        <ShelfInnerRow
          key={index}
          shelf={shelf}
          setReloadShelf={setReloadShelf}
          handleOpenModal={() => handleOpenAddModal(shelf)}
        />
      ))}
    </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {isPagination ? null : (
        <CustomPagination
          totalCount={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};

export default ShelfTable;
